import moment from 'moment';
import FormRules from './form-rules';

export default {
  data() {
    return {
      allRules: FormRules
    }
  },
  methods: {
    filterByDate(first, second) {
      const res = moment(first).isSame(second);
      return res;
    },
    $clean(obj) {
      const source = this.clone(obj);
      const keys = Object.keys(source);
      keys.forEach(key => {
        if (!source[key]) delete source[key];
      });
      return source;
    },
    addToArr(arr, element) {
      if (arr.length == 0) {
        arr = [element];
      } else this.$set(arr, arr.length, element);
    },
    updateArr(arr, element) {
      const i = arr.indexOf(arr.filter(e => e.id == element.id)[0]);
      if (arr.length == 0) arr.push({});
      this.$set(arr, i, element);
    },
    round(num, percesion) {
      if (!percesion) percesion = 2;
      const factor = 10 ** percesion;
      return Math.round(num * factor) / factor;
    },
    clone(thing, opts) {
      const newObject = {};
      const vm = this;
      if (thing instanceof Array) {
        return thing.map((i) => vm.clone(i, opts));
      } if (thing instanceof Date) {
        return new Date(thing);
      } if (thing instanceof RegExp) {
        return new RegExp(thing);
      } if (thing instanceof Function) {
        return opts && opts.newFns
          ? new Function(`return ${thing.toString()}`)()
          : thing;
      } if (thing instanceof Object) {
        Object.keys(thing).forEach((key) => {
          newObject[key] = vm.clone(thing[key], opts);
        });
        return newObject;
      } if ([undefined, null].indexOf(thing) > -1) {
        return thing;
      }
      if (thing.constructor.name === 'Symbol') {
        return Symbol(thing.toString()
          .replace(/^Symbol\(/, '')
          .slice(0, -1));
      }
      // return _.clone(thing);  // If you must use _ ;)
      return thing.__proto__.constructor(thing);

    },
    getEnumMember(enumClass, enumValue) {
      for (const val in enumClass) {
        if (enumClass[val].value == enumValue) return enumClass[val];
      }
      return {};
    },
    formatDate(d) {
      return this.formateDateWithMoment(d, 'YYYY-MM-DD');
      try {
        const date = new Date(Date.parse(d));
        const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
        const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(date)
        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date)
        return `${da} ${mo} ${ye}`;
      } catch {
        return 'unknown'
      }

    },
    formateDateWithMoment(date, formats) {
      if (!date) return null
      return moment(date).format(formats)
    },
    showToast(variant, title, content) {
      this.$bvToast.toast(content, {
        title,
        variant,
        solid: true,
        content
      });
    },

  }
}